import { editableTableLib, editableTableUI } from 'components/editable-table';

const onCell =
  (col: Partial<editableTableLib.DataColumn>, editingKey: React.Key) =>
  (record: editableTableLib.DataType) => ({
    record,
    dataIndex: col.dataIndex,
    title: col.title,
    editing: editingKey === record.key,
    required: col.required,
    inputType: col.inputType,
    inputStyle: col.inputStyle,
  });

export const formatColumns = ({
  columns,
  editingKey,
  form,
  mutationReq,
  setEditingKey,
}: editableTableLib.FromatColumnsProps): editableTableLib.DataColumn[] => {
  let fields: editableTableLib.DataColumn[] = [];

  fields = columns.map((col) => {
    if (col.editable) {
      return { ...col, onCell: onCell(col, editingKey) } as editableTableLib.DataColumn;
    }
    return { ...col };
  });

  fields.push({
    title: '',
    dataIndex: 'edit',
    width: 110,
    align: 'center',
    fixed: 'right',
    render: (_, record) =>
      editableTableUI.renderEdit({
        record,
        editingKey,
        setEditingKey,
        form,
        mutationReq,
      }),
  });

  return fields;
};
